import { ContactDealerEmailDetailsProps } from '../../../types';
import styles from '../../../Product.module.scss';
import cx from 'classnames';

export const ContactDealerEmailDetails = ({
  label,
  textClassName,
  email
}: ContactDealerEmailDetailsProps) => {
  return (
    <p className={cx(textClassName, styles['product-text'])}>
      <span className={cx('fw-bold', textClassName, styles['product-text'])}>
        {label}
      </span>
      <br />
      <a href={`mailto:${email}`}>{email}</a>
    </p>
  );
};
